export default __webpack_public_path__ + "static/icon-aa35233a96cb690c271ca3a4846f5762.png";